import React, {Component} from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {CreateNewTable, GetCartData, RefreshTable, ViewTable,} from "../../../redux/actions/Cart.Action";
import {fetchTable} from "../../../redux/actions/Socket.Action";

class CartTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tableGroup: true,
      tables: [],
      viewModal: false,
      product: false,
    };
  }
  componentDidMount() {
    if (this.props.CurrentCart && this.props.CurrentCart.length === 0) {
      this.props.RefreshTable();
      this.props.fetchTable();
    }
  }
  ViewTable(group) {
    this.props.ViewTable(group);
    this.setState({ tableGroup: false });
  }
  BackToGroup() {
    if (this.props.waiter) {
      this.props.RefreshTable();
    }
    this.setState({ tableGroup: true });
  }
  GetCart(table, group, target) {
    this.props.GetCartData(table, group, target);
    if (this.props.waiter) {
      this.props.history.push("/Waiter/ProductList");
    }
  }

  render() {
    const tableData = this.props.CartTableGroup || [];
    const tables = this.props.CartTables || [];
    return (
      <div className="justify-content-center text-center ">
        <ul className="waiter-table  row justify-content-center">
          {this.state.tableGroup ? (
            tableData.map((tableData, index) => (
              <li
                className="bg-info tex-center"
                key={index}
                onClick={() => this.ViewTable(tableData.id)}
              >
                <div className="row">
                  <div className="col">
                    <span className="title"> {tableData.name}</span>
                  </div>
                  <div className="col">
                    <span className="subtitle">
                      {
                        tableData.tables.filter((tables) => tables.status === 1)
                          .length
                      }{" "}
                      Open
                    </span>
                  </div>
                </div>
              </li>
            ))
          ) : (
            <>
              <li
                className="bg-cyan"
                onClick={() => {
                  this.BackToGroup();
                }}
              >
                <div className="text-center">
                  <span className="material-icons-outlined fs-40 p-0">
                    undo
                  </span>
                </div>

                <div className="d-flex align-items-end justify-content-center">
                  <span className="subtitle">Back</span>
                </div>
              </li>
              {tables.map((table, index) => (
                <React.Fragment key={index}>
                  {table.status === 1 ? (
                    <React.Fragment>
                      {table.current === 1 ? (
                        <li className="active" key={index}>
                          <div className="d-flex align-items-start justify-content-between">
                            <span className="material-icons-outlined">
                              people
                            </span>
                            <span className="title"> {table.table}</span>
                          </div>

                          <div className="d-flex align-items-center">
                            <span className="subtitle">RS.{table.total}</span>
                          </div>
                          <div className="d-flex align-items-end justify-content-between">
                            <p>{table.guest} People</p>
                          </div>
                        </li>
                      ) : (
                        <li
                          className="bg-warning"
                          onClick={(e) => {
                            this.GetCart(table.table, table.groupid, e.target);
                          }}
                          key={index}
                        >
                          <div className="d-flex align-items-start justify-content-between">
                            <span className="material-icons-outlined">
                              people
                            </span>
                            <span className="title"> {table.table}</span>
                          </div>

                          <div className="d-flex align-items-center">
                            <span className="subtitle">RS.{table.total}</span>
                          </div>
                          <div className="d-flex align-items-end justify-content-between">
                            <p>{table.guest} People</p>
                          </div>
                        </li>
                      )}
                    </React.Fragment>
                  ) : (
                    <li
                      className="bg-success text-white"
                      onClick={(e) =>
                        this.props.CreateNewTable(
                          table.table,
                          0,
                          table.groupid,
                          e.target
                        )
                      }
                      key={index}
                    >
                      <div className="d-flex align-items-start justify-content-between">
                        <span className="material-icons-outlined"></span>
                        <span className="title"> {table.table}</span>
                      </div>
                      <div className="text-center">
                        <span className="material-icons-outlined fs-40 p-0">
                          dining
                        </span>
                      </div>
                    </li>
                  )}
                </React.Fragment>
              ))}
            </>
          )}
          {/* <li className="empty">
              <div className="d-flex align-items-start justify-content-between">
                <span className="material-icons-outlined">people</span>
                <span className="title">T1</span>
              </div>

              <div className="d-flex align-items-center">
                <span className="subtitle">RS.199999</span>
              </div>
              <div className="d-flex align-items-end justify-content-between">
                <span>2 People</span>
              </div>
            </li>
            <li className="pending">
              <div className="d-flex align-items-start justify-content-between">
                <span className="material-icons-outlined">people</span>
                <span className="title">T1</span>
              </div>

              <div className="d-flex align-items-center">
                <span className="subtitle">RS.199999</span>
              </div>
              <div className="d-flex align-items-end justify-content-between">
                <span>2 People</span>
              </div>
            </li>
            <li className="active">
              <div className="d-flex align-items-start justify-content-between">
                <span className="material-icons-outlined">people</span>
                <span className="title">T1</span>
              </div>

              <div className="d-flex align-items-center">
                <span className="subtitle">RS.199999</span>
              </div>
              <div className="d-flex align-items-end justify-content-between">
                <span>2 People</span>
              </div>
            </li> */}
        </ul>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    CartTableGroup: state.Cart.Table.group,
    CartTables: state.Cart.Table.table,
    CurrentCart: state.Cart.CurrentCart,
  }),
  { GetCartData, RefreshTable, ViewTable, CreateNewTable, fetchTable }
)(withRouter(CartTable));
